import type { NamespaceTester } from "src/lib/i18next/types.ts";
import { OrderTranslationNamespaceEnum } from "src/admin/modules/order/constants.ts";

export const exceptions: NamespaceTester = (ns: string, lang: string) => {
  const exceptions = {
    [OrderTranslationNamespaceEnum.CreateOrder]: `src/admin/modules/order/routes/create/create-order/create.general.${lang}.json`,
  };

  if (exceptions[ns]) {
    return exceptions[ns];
  }
};
